import React, { useEffect, useRef } from 'react'
import { TfiFilter } from 'react-icons/tfi'
import IonIcon from '@reacticons/ionicons'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import TrainFilterDropdownPopup from '../../../components/trainfilterdropdownpopup'

const TicketTable = ({
  tickets,
  currentPage,
  totalPages,
  startItem,
  endItem,
  totaltickets,
  statusfilter,
  priorityfilter,
  startDate,
  endDate,
  search,
  customer_search,
  error,
  onfiltering,
  ripple,
  isopenpopup,
  datepickerref,
  setstatusfilter,
  setpriorityfilter,
  setDateRange,
  setcustomer_search,
  setSearch,
  SetSettingsPopupOpen,
  handleStatusChange,
  handlepriority,
  handlePageChange,
  handleopenClosedropdown,
  handleResetClick,
  handlefilterSubmit,
  handleopenpreview,
  ticket_delete,
  createRipple,
  closefilterpopup,
  closefilterpopupeye,
  runTour,
  stepIndex,
  handleJoyrideCallback
}) => {
  const tableContainerRef = useRef(null)

  useEffect(() => {
    const scrollContainer = tableContainerRef.current

    const cleanupStyles = () => {
      if (scrollContainer) {
        scrollContainer.scrollLeft = 0
        scrollContainer.scrollTop = 0
      }
    }

    if (runTour && stepIndex !== null) {
      const allSteps = [
        '.ticketno',
        '.customer',
        '.ticketstatus',
        '.ticketpriority',
        '.message',
        '.ticketdate',
        '.ticketaction'
      ]

      const selector = allSteps[stepIndex]
      if (selector) {
        const target = document.querySelector(selector)
        const tableHeader = document.querySelector('thead tr')

        if (target && tableHeader && scrollContainer) {
          const targetRect = target.getBoundingClientRect()
          const headerRect = tableHeader.getBoundingClientRect()
          const viewportHeight = window.innerHeight
          const currentScroll = scrollContainer.scrollTop

          if (targetRect.top < headerRect.bottom) {
            const adjustment = headerRect.bottom - targetRect.top + 20
            scrollContainer.scrollTo({
              top: currentScroll - adjustment,
              behavior: 'smooth'
            })
          }

          const scrollLeft = scrollContainer.scrollLeft
          const targetLeft = target.offsetLeft
          const targetWidth = target.offsetWidth
          const containerWidth = scrollContainer.offsetWidth

          const targetCenter = targetLeft - containerWidth / 2 + targetWidth / 2
          scrollContainer.scrollTo({
            left: targetCenter,
            behavior: 'smooth'
          })

          const isMobile = window.innerWidth < 768
          if (isMobile) {
            setTimeout(() => {
              const tooltip = document.querySelector('.react-joyride__tooltip')
              if (tooltip) {
                const tooltipHeight = tooltip.offsetHeight
                const spaceBelow = viewportHeight - targetRect.bottom

                if (spaceBelow < tooltipHeight + 20) {
                  const neededScroll = tooltipHeight + 20 - spaceBelow
                  scrollContainer.scrollTo({
                    top: currentScroll + neededScroll,
                    behavior: 'smooth'
                  })
                }
              }
            }, 300)
          }
        }
      }
    }

    return () => {
      cleanupStyles()
    }
  }, [stepIndex, runTour])

  const enhancedHandleJoyrideCallback = data => {
    const { action, index, type } = data

    if (type === 'tour:end' || action === 'close' || action === 'skip') {
      const scrollContainer = tableContainerRef.current

      if (scrollContainer) {
        scrollContainer.scrollLeft = 0
        scrollContainer.scrollTop = 0
      }

      // Force a reflow to ensure styles are properly reset
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    }

    handleJoyrideCallback(data)
  }

  return (
    <div className='relative flex-1 h-auto bg-white mt-[15px] rounded-[16px] shadow-md'>
      <div className='p-4 '>
        <div className='mb-5 flex justify-between flex-wrap gap-3'>
          <h1 className='text-[#252530] font-extrabold text-[23px]'>
            Ticket Management
          </h1>
          <div className='flex gap-3 flex-wrap'>
            <div className='relative'>
              <div className='relative w-full ticketfilter'>
                <button
                  onClick={event => {
                    createRipple(event)
                    handleopenClosedropdown()
                  }}
                  className={`relative bg-[#f4f4f4] py-[11px] px-[11px] rounded-[8px] border-[0.5px] cursor-pointer hover:bg-gray-200 transition-all ${
                    isopenpopup && 'bg-gray-200'
                  }`}
                >
                  <TfiFilter size={16} />
                  {ripple.map(({ x, y, id }) => (
                    <span
                      key={id}
                      className='absolute block bg-white opacity-100 rounded-full animate-ripple'
                      style={{
                        top: y,
                        left: x,
                        width: '20px',
                        height: '20px',
                        transform: 'translate(50%, 50%)'
                      }}
                    ></span>
                  ))}
                </button>
                {onfiltering && (
                  <span className='absolute right-[0.1px] top-[-1px] bg-green-400 w-2 h-2 rounded'></span>
                )}
              </div>

              {isopenpopup && (
                <TrainFilterDropdownPopup
                  isopenpopup={closefilterpopup}
                  clearbtn={handleResetClick}
                  fields={[
                    <div className='flex relative w-full'>
                      <div className='flex flex-col w-full justify-start'>
                        <p className='text-[#7A7D9C] text-[14px] mb-1'>
                          Status
                        </p>
                        <select
                          name='status'
                          value={statusfilter}
                          onChange={e => setstatusfilter(e.target.value)}
                          className='w-full cursor-pointer border border-[#BFC4D7] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none appearance-none'
                        >
                          <option value=''>---</option>
                          <option value='open'>Open</option>
                          <option value='inprogress'>In Progress</option>
                          <option value='resolved'>Resolved</option>
                          <option value='closed'>Closed</option>
                        </select>
                        <IonIcon
                          name='chevron-down'
                          className='absolute right-2 top-[58%] text-gray-500 cursor-pointer pointer-events-none'
                        />
                      </div>
                    </div>,

                    <div className='flex relative w-full'>
                      <div className='flex flex-col w-full justify-start'>
                        <p className='text-[#7A7D9C] text-[14px] mb-1'>
                          Priority
                        </p>
                        <select
                          name='priority'
                          value={priorityfilter}
                          onChange={e => setpriorityfilter(e.target.value)}
                          className='w-full cursor-pointer border border-[#BFC4D7] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none appearance-none'
                        >
                          <option value=''>---</option>
                          <option value='Highest'>Highest</option>
                          <option value='High'>High</option>
                          <option value='Medium'>Medium</option>
                          <option value='Low'>Low</option>
                        </select>
                        <IonIcon
                          name='chevron-down'
                          className='absolute right-2 top-[58%] text-gray-500 cursor-pointer pointer-events-none'
                        />
                      </div>
                    </div>,

                    <div className='relative flex cursor-pointer w-full'>
                      <div className='flex flex-col w-full justify-start'>
                        <p className='text-[#7A7D9C] text-[14px] mb-1'>
                          Date Range
                        </p>
                        <DatePicker
                          ref={datepickerref}
                          selected={startDate}
                          onChange={update => setDateRange(update)}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange
                          dateFormat='yyyy-MM-dd'
                          autoComplete='off'
                          name='daterange'
                          className='w-full border border-[#BFC4D7] placeholder:text-[#ABADB5] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none'
                        />
                        {error && (
                          <p className='text-red-500 text-sm absolute bottom-[-18px]'>
                            {error}
                          </p>
                        )}
                      </div>
                      <IonIcon
                        name='calendar-outline'
                        className='absolute right-2 top-[58%] text-gray-500 cursor-pointer'
                        onClick={() => datepickerref.current.setOpen(true)}
                      />
                    </div>,

                    <div className='flex relative w-full'>
                      <div className='flex flex-col w-full justify-start'>
                        <p className='text-[#7A7D9C] text-[14px] mb-1'>
                          Customer Name or Email
                        </p>
                        <input
                          type='text'
                          value={customer_search}
                          onChange={e => setcustomer_search(e.target.value)}
                          className='w-full border border-[#BFC4D7] py-2 pl-3 pr-9 rounded-[6px] text-sm focus:outline-none appearance-none'
                        />
                      </div>
                    </div>
                  ]}
                  onsubmit={handlefilterSubmit}
                />
              )}
            </div>

            <div className='flex relative w-full sm:w-auto'>
              <input
                type='text'
                placeholder='Search by ticket# or Message'
                value={search}
                onChange={e => setSearch(e.target.value)}
                className='focus:outline-none w-full sm:w-[254px] h-[41px] rounded-[39px] border-[0.5px] pl-[30px] pr-[40px] bg-[#F4F4F4] placeholder:text-[#565656] placeholder:text-[12px] text-[14px]'
              />
              <svg
                width='16'
                height='15'
                className='absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer'
                viewBox='0 0 16 15'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M15.0555 13.3145L11.7477 10.0066C12.544 8.94645 12.9739 7.65598 12.9725 6.33C12.9725 2.94305 10.217 0.1875 6.83 0.1875C3.44305 0.1875 0.6875 2.94305 0.6875 6.33C0.6875 9.71695 3.44305 12.4725 6.83 12.4725C8.15598 12.4739 9.44645 12.044 10.5066 11.2477L13.8145 14.5555C13.9819 14.7052 14.2003 14.7851 14.4248 14.7788C14.6493 14.7725 14.8629 14.6805 15.0217 14.5217C15.1805 14.3629 15.2725 14.1493 15.2788 13.9248C15.2851 13.7003 15.2052 13.4819 15.0555 13.3145ZM2.4425 6.33C2.4425 5.46223 2.69982 4.61396 3.18193 3.89244C3.66403 3.17092 4.34927 2.60856 5.15098 2.27648C5.95269 1.9444 6.83487 1.85751 7.68596 2.0268C8.53705 2.1961 9.31883 2.61397 9.93243 3.22757C10.546 3.84117 10.9639 4.62295 11.1332 5.47404C11.3025 6.32513 11.2156 7.20731 10.8835 8.00902C10.5514 8.81073 9.98909 9.49597 9.26756 9.97807C8.54604 10.4602 7.69777 10.7175 6.83 10.7175C5.66679 10.7161 4.55162 10.2534 3.72911 9.43089C2.9066 8.60838 2.4439 7.49321 2.4425 6.33Z'
                  fill='#0F062C'
                  fillOpacity='0.7'
                />
              </svg>
            </div>

            <button
              onClick={() => {
                SetSettingsPopupOpen(true)
                closefilterpopupeye()
              }}
              className='flex justify-center items-center'
            >
              <IonIcon name='settings-outline' className='text-[25px]' />
            </button>
          </div>
        </div>

        <div className='w-full tableclass overflow-x-auto'>
          <table className='w-full  table-auto'>
            <thead>
              <tr className='border-b'>
                <th className='p-3 text-left font-bold text-[14px] min-w-[120px] whitespace-nowrap'>
                  <p className='ticketno inline-flex'>Ticket #</p>
                </th>
                <th className='p-3 text-left font-bold text-[14px] min-w-[150px] whitespace-nowrap'>
                  <p className='customer inline-flex'>Customer</p>
                </th>
                <th className='p-3 text-left font-bold text-[14px] min-w-[120px] whitespace-nowrap'>
                  <p className='ticketstatus inline-flex'>Status</p>
                </th>
                <th className='p-3 text-left font-bold text-[14px] min-w-[120px] whitespace-nowrap'>
                  <p className='ticketpriority inline-flex'>Priority</p>
                </th>
                <th className='p-3 text-left font-bold text-[14px] min-w-[200px] whitespace-nowrap'>
                  <p className='message inline-flex'>Message</p>
                </th>
                <th className='p-3 text-left font-bold text-[14px] min-w-[150px] whitespace-nowrap'>
                  <p className='ticketdate inline-flex'>Created Date</p>
                </th>
                <th className='p-3 text-left font-bold text-[14px] min-w-[150px] whitespace-nowrap'>
                  <p className='ticketaction inline-flex'>Action</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {tickets.length === 0 ? (
                <tr>
                  <td colSpan='7' className='text-center py-4'>
                    No data available
                  </td>
                </tr>
              ) : (
                tickets.map(t => (
                  <tr key={t.ticket_id} className='border-b'>
                    <td className='p-3 text-[11.5px]'>{t.ticket_number}</td>
                    <td className='p-3 text-[11.5px]'>
                      {t.ChatUsers[0].name}
                      <br />
                      <span className='text-xs text-gray-500'>
                        {t.ChatUsers[0].email}
                      </span>
                    </td>
                    <td className='p-3 text-[11.5px]'>
                      <select
                        value={t.status}
                        onChange={e =>
                          handleStatusChange(
                            t.ticket_id,
                            t.ticket_number,
                            e.target.value
                          )
                        }
                        className='border rounded-md px-2 py-1 focus:outline-none'
                      >
                        <option value='open'>Open</option>
                        <option value='inprogress'>In Progress</option>
                        <option value='resolved'>Resolved</option>
                        <option value='closed'>Closed</option>
                      </select>
                    </td>
                    <td className='p-3 text-[11.5px]'>
                      <select
                        value={t.priority}
                        onChange={e =>
                          handlepriority(
                            t.ticket_id,
                            t.ticket_number,
                            e.target.value
                          )
                        }
                        className='border rounded-md px-2 py-1 focus:outline-none'
                      >
                        <option value='Highest'>Highest</option>
                        <option value='High'>High</option>
                        <option value='Medium'>Medium</option>
                        <option value='Low'>Low</option>
                      </select>
                    </td>
                    <td className='p-3 text-[11.5px] max-w-[290px] break-words whitespace-normal'>
                      {t.content}
                    </td>
                    <td className='p-3 text-[11.5px]'>
                      {new Date(t.createdAt).toLocaleString('en-US', {
                        timeZone: 'UTC'
                      })}
                    </td>
                    <td className='p-3 text-[14.5px] text-center'>
                      <div className='flex gap-4 items-center justify-center'>
                        <IonIcon
                          name='eye-outline'
                          onClick={() => {
                            closefilterpopupeye()
                            handleopenpreview(t.chat_id, t, t.ticket_id)
                          }}
                          className='cursor-pointer'
                        />
                        <IonIcon
                          name='trash-outline'
                          onClick={() => ticket_delete(t.ticket_id)}
                          className='cursor-pointer hover:text-red-600'
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className='flex justify-between items-center p-3 mt-2'>
          <span className='font-semibold text-[12px]'>
            {startItem} - {endItem} of {totaltickets}
          </span>
          <div className='flex items-center gap-2'>
            <button
              onClick={() => handlePageChange('prev')}
              disabled={currentPage === 1}
              className='p-2'
            >
              &lt;
            </button>
            <span className='text-[12px] font-semibold'>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => handlePageChange('next')}
              disabled={currentPage === totalPages}
              className='p-2'
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TicketTable
